import { InfoRowTypes } from './types';

import cn from './info.module.css';

const InfoRow = ({ title, value }: InfoRowTypes) => (
  <div className={cn.infoRow}>
    <div className={cn.infoRowTitle}>{title}</div>
    <div className={cn.infoRowValue}>{value}</div>
  </div>
);

export default InfoRow;
